import React, { useMemo } from 'react';

import classnames from 'classnames';

import SeparatorList from 'components/uiLibrary/SeparatorList';
import Typography from 'components/uiLibrary/Typography';

import EntityName from 'components/Globals/EntityName';

import { getProgramLabel } from 'utils/common';
import { getProductionTitles } from 'utils/productions';

import { useTranslation } from 'src/i18n';

import { ENTITY_TYPES } from 'operabase-router/constants';

import classes from './Titles.module.scss';

const Titles = ({ data, isCancelled, trackingData, styles, isFeaturedPerformance }) => {
  const titles = useMemo(() => getProductionTitles(data), [data]);
  const { t } = useTranslation('NS_APP_GLOBALS');

  return (
    <div>
      {titles?.map(({ title, translation, composers, entityType: titleEntityType, entityId, isCustomTitle }, index) => (
        <Typography
          key={index}
          variant="p"
          strikethrough={isCancelled}
          className={classnames(classes.prodTitle, {
            [classes.prodTitle__featuredCard]: isFeaturedPerformance,
            [styles?.prodTitle]: !!styles?.prodTitle,
          })}
        >
          <Typography weight="bold" size={14}>
            <EntityName
              name={title}
              entityType={titleEntityType}
              entity={{ id: entityId }}
              // NOTE: ENTITY_TYPES.PRODUCTION is covered as part of ProductionSlug using ImpressionTracker
              trackingData={titleEntityType === ENTITY_TYPES.PRODUCTION ? undefined : trackingData}
              isRaw={!isCustomTitle}
            />
          </Typography>
          {translation && (
            <Typography variant="span" size={14} color="secondary">
              {' '}
              ({translation})
            </Typography>
          )}
          <Typography variant="span" size={14} color="secondary" italic>
            ,{' '}
            <SeparatorList
              data={composers?.map(props => (
                <EntityName key={props?.entity?.id} {...props} trackingData={trackingData} />
              ))}
            />
          </Typography>
          {data?.isProgramNotAnnounced && (
            <Typography className={classes.programNotAnnounced} variant="p" size={12} italic color="secondary">
              *{t(getProgramLabel(data, data?.productionWorks?.length))}
            </Typography>
          )}
        </Typography>
      ))}
    </div>
  );
};

export default Titles;
